var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M5.305 15.475 11.998 9 5.25 2.525l1.094-1.203 6.923 6.683a1.455 1.455 0 0 1 0 2.045l-6.836 6.606z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export default ForwardRef;